import React from "react";
import styled from "styled-components";

import { Spinner } from "ui/components/styled";

const Wrapper = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;

export const LoadingView = () => {
  return (
    <Wrapper>
      <Spinner />
      <span>Loading...</span>
    </Wrapper>
  );
};
